<template>
  <div class="act-paoma" :style="wrapStyle">
    <transition name="fade">
      <div class="item" :style="itemStyle" v-for="(item,index) in records" :key="index" v-if="index === current_show">
        {{item}}
      </div>
    </transition>
  </div>
</template>
<script>
  import {getJSON} from '../../api/myaxios';

  export default {
    name: 'ActPaomadeng',
    props: {
      records: {
        type: Array,
        default: function () {
          return []
        }
      },
      color: {
        type: String,
        default: 'white'
      },
      bg: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        current_show: 0,
        interval: null
      }
    },
    methods: {
      startShow() {
        if (!this.records || this.records.length === 0) {
          return
        }
        window.clearInterval(this.interval);
        this.interval = null;
        this.current_show = 0;
        const len = this.records.length;
        if (len === 0) {
          return;
        }
        this.interval = setInterval(() => {
          this.current_show = (this.current_show + 1) % len;
        }, 2000);
      }
    },
    mounted() {
      this.startShow()
    },
    watch: {
      records(val) {
        if (val) {
          setTimeout(this.startShow, 1500); //稍微晚一点开始，等待背景加载
        }
      }
    },
    computed: {
      wrapStyle() {
        return {
          background: `url(${this.bg}) 0% 0% / cover no-repeat`
        }
      },
      itemStyle() {
        return {
          color: `${this.color} !important`,
        }

      }
    }
  }
</script>
<style lang="stylus" scoped>
  .act-paoma
    height 0.49rem
    overflow hidden
    width 100%
    color white
    position relative

    .item
      height 0.49rem
      line-height 0.49rem
      position absolute
      text-align center
      width 100%
      font-size 0.28rem

    .fade-enter-active {
      transition: all .5s;
    }

    .fade-leave-active {
      transition all 0;
    }

    .fade-enter {
      transform translate(0, 1rem)
    }

    .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
      transform translate(0, 1rem)
    }
</style>






// WEBPACK FOOTER //
// src/components/ConfigUI/ActPaomadeng.vue